<template>
  <div>
    <listaGrupo grupo></listaGrupo>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import listaGrupo from "@/components/Beneficiarios/ListaAfiliados";
import API from "../../../lib/API";
export default {
  data() {
    return {};
  },
  components: {
      listaGrupo
  },
  computed: {
    ...mapState("beneficiarios", ["Titular", "GrupoFamiliar", "Seleccionado"]),
    ...mapState("autogestion", ["Usuario"]),
    logueado() {
      return this.Seleccionado !== undefined && this.Seleccionado !== null;
    },
  },
  methods: {
    ...mapActions("autogestion", ["inicializar"]),
    ...mapActions("beneficiarios", ["select", "modificarBeneficiario"]),
  },
  async mounted() {
    if (!this.Usuario) {
      await this.inicializar();
      if (!this.Usuario) {
        this.$router.push({ name: "Autogestion" });
      }
    }
    if (this.Usuario && this.Seleccionado == undefined) {
      let ben = await API.Beneficiarios.traerUno(this.Usuario.UserId);
      this.select(ben);
    }
  },
};
</script>

<style></style>
